<template>
  <div>
    <CSPageContainer>
      <SystemMaintenance v-if="showNotification" />

      <router-view />
    </CSPageContainer>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import store from "@/store";
import CSPageContainer from "@/components/CharitySystem/CSPageContainer.vue";
import SystemMaintenance from "./SystemMaintenance.vue";

const showNotification = computed(
  () => store.state.systemSetting?.systemNotification
);
</script>
